// tslint:disable:variable-name

export class SignupData {
    // Identification
    email: string;
    name: string;

    // Additional info
    about: string;
    time_zone: string;
    language: string;
    theme: string;

    // Security
    password: string;
}
